<template>
  <div>
    <PageHeader :title="`รายงาน${menuTitle}`"></PageHeader>
    <b-container class="mt-5 px-5" fluid>
      <b-card class="no-shadow" no-body>
        <b-tabs v-model="tabIndex" card>
          <b-tab title="แยกตามหนังสือ">
            <BookDeliveryPurchaseTab :tabIndex="0" :menuTitle="menuTitle" />
          </b-tab>
          <b-tab title="แยกตามคอร์ส">
            <BookDeliveryPurchaseTab :tabIndex="1" :menuTitle="menuTitle" />
          </b-tab>
        </b-tabs>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import PageHeader from "../../layouts/PageHeader";
import BookDeliveryPurchaseTab from "./panel/BookDeliveryPurchaseTab.vue";

export default {
  components: { PageHeader, BookDeliveryPurchaseTab },
  data() {
    return {
      tabIndex: 0,
    };
  },
  computed: {
    menuTitle() {
      if (this.tabIndex === 0) {
        return "การซื้อที่ต้องรับ/ส่งหนังสือ";
      } else if (this.tabIndex === 1) {
        return "หนังสือที่รับ/ส่ง";
      }

      return "";
    },
  },
};
</script>

<style scoped>
.card-body {
  padding: 36px 75px;
}
</style>
